<template>
  <div class='ztbContent'>
    <div  class='sub-nav'>
      <div class='sub-nav-wrap'>
        <div class='sub-nav-item'>
          <router-link to="/ggList/1" clstag="pageclick|keycount|Pcpaimai_tender|entrance_tendernotice">招标公告</router-link>
          <router-link to="/ggList/2" clstag="pageclick|keycount|Pcpaimai_tender|entrance_changenotice" :class='{"router-link-exact-active router-link-active":2==this.$route.query.Pid}'>变更公告</router-link>
          <router-link to="/ggList/3" clstag="pageclick|keycount|Pcpaimai_tender|entrance_reviewnotice">评标公示</router-link>
          <router-link to="/ggList/5" clstag="pageclick|keycount|Pcpaimai_tender|entrance_winnotice" >中标公告</router-link>
          <router-link to="/helpCenter">帮助中心</router-link>
        </div>
      </div>
    </div>
    <div class='content'>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  methods:{
    
  },
  mounted(){
  }
}

</script>
<style lang="less" scoped>
.sub-nav{
  border-bottom:2px solid #000;
  background:#fff;
  .sub-nav-wrap{
    width:1210px;
    margin:0 auto;
    .sub-nav-item{
      text-align: left;
      a{
        font-size: 16px;
        cursor: pointer;
        margin-right:25px;
        text-decoration: none;
        color:#333;
        text-align:center;
        display: inline-block;
        padding:30px 0 14px 0;
      }
      a+a{
        margin-left:25px;
      }
      .router-link-exact-active.router-link-active,.router-link-active{
        color:#cc2729;
        font-weight: bold;
        border-bottom:4px solid #cc2729;
      }
    }
  }
}
</style>
